/**
 * Related Products Color Variant Handler
 * Separate script to handle color variants in related products section
 */

(function() {
    function initializeRelatedProductVariants() {
        // Only target related products section
        const relatedProducts = document.querySelector('.related-products');
        if (!relatedProducts) return;
        
        // Find all color variant containers in related products
        const variantContainers = relatedProducts.querySelectorAll('.card-wrapper .color-variants');
        
        variantContainers.forEach(container => {
            // Skip if already initialized
            if (container.dataset.relatedInit === 'true') return;
            container.dataset.relatedInit = 'true';
            
            const variants = container.querySelectorAll('.color-variant');
            const cardWrapper = container.closest('.card-wrapper');
            
            if (!cardWrapper) return;
            
            // Find the product image
            const productImage = cardWrapper.querySelector('.card__media img');
            
            variants.forEach(variant => {
                variant.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Update active state
                    variants.forEach(v => v.classList.remove('active'));
                    this.classList.add('active');
                    
                    // Get image URL
                    const newImageUrl = this.dataset.image || this.dataset.main;
                    
                    if (newImageUrl && productImage) {
                        // Update the product image
                        productImage.src = newImageUrl;
                        
                        // Update srcset for responsive images
                        const baseSrc = newImageUrl.replace(/\?.*$/, '');
                        const srcsetSizes = [165, 360, 533, 720, 940, 1066];
                        const newSrcset = srcsetSizes.map(size => 
                            `${baseSrc}?width=${size} ${size}w`
                        ).join(', ');
                        productImage.srcset = newSrcset;
                    }
                    
                    // Update color label if exists
                    const colorLabel = container.parentElement.querySelector('.color-variant-label-text');
                    if (colorLabel) {
                        colorLabel.textContent = this.dataset.color;
                    }
                    
                    // Update product links with variant parameter
                    const productLinks = cardWrapper.querySelectorAll('a[href*="/products/"]');
                    const variantId = this.dataset.variantId;
                    
                    if (productLinks && variantId) {
                        productLinks.forEach(link => {
                            const url = new URL(link.href);
                            url.searchParams.set('variant', variantId);
                            link.href = url.toString();
                        });
                    }
                });
            });
        });
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeRelatedProductVariants);
    } else {
        initializeRelatedProductVariants();
    }
    
    // Also initialize when page fully loads (for dynamically loaded content)
    window.addEventListener('load', function() {
        setTimeout(initializeRelatedProductVariants, 500);
    });
    
    // Watch for dynamically loaded related products
    if (window.MutationObserver) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1 && node.classList && node.classList.contains('related-products')) {
                            setTimeout(initializeRelatedProductVariants, 100);
                        }
                    });
                }
            });
        });
        
        observer.observe(document.body, { childList: true, subtree: true });
    }
})();
